// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const BlogContainerTheme: ThemeFile = {
  aw: {
    classes: {
      contentWrapper: 'block col-span-12',
    },
  },
  rba: {
    classes: {
      contentWrapper: 'block col-span-12',
    },
  },
};
